import CustomDialog from "../../../../../../../../utils/CustomDialog";

const PresentationWizardDialog = ({ title, open, onClose, children }) => {
  return (
    <CustomDialog
      onClose={onClose}
      open={open}
      title={title}
      isBottom={true}
      heigth={600}
    >
      {children}
    </CustomDialog>
  );
};

export default PresentationWizardDialog;